import { useEffect, useState } from 'react';
import healthService, { NewClientPause } from '../api/services/health';

const INACTIVE: NewClientPause = { active: false, pauseStart: null };

// Fetched once per page load and shared across all consumers of the hook.
let cachedPause: NewClientPause | null = null;
let pendingFetch: Promise<NewClientPause> | null = null;

const fetchPause = (): Promise<NewClientPause> => {
  if (cachedPause) return Promise.resolve(cachedPause);

  if (!pendingFetch) {
    pendingFetch = healthService
      .find()
      .then((health) => {
        cachedPause = health.newClientPause ?? INACTIVE;
        return cachedPause;
      })
      .catch(() => {
        // Fail open: never degrade the experience because the health check failed
        cachedPause = INACTIVE;
        return cachedPause;
      });
  }

  return pendingFetch;
};

/**
 * Reads the new-client pause state from the public /health endpoint, so the
 * pause can be toggled via the API env var with no frontend rebuild.
 */
const useNewClientPause = () => {
  const [pause, setPause] = useState<NewClientPause>(cachedPause ?? INACTIVE);
  const [loading, setLoading] = useState(!cachedPause);

  useEffect(() => {
    let mounted = true;
    fetchPause().then((result) => {
      if (mounted) {
        setPause(result);
        setLoading(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return { pauseActive: pause.active, pauseStart: pause.pauseStart, loading };
};

export default useNewClientPause;
